import React, { CSSProperties, ReactNode } from "react";
import { useNavigate } from "react-router-dom";

import "./HeaderWithTitleAndBackButton.scss";
import ChevronLeftCircleIcon from "../../icons/ChevronLeftCircleIcon";
import { ROUTES } from "../../../utils/constants";
import GhostButton from "../../dashboard-page/GhostButton/GhostButton";

interface HeaderWithTitleAndBackButtonProps {
  title: {
    text: string;
    color?: string;
  };
  backRoute?: string;
  backIconEl?: ReactNode;
  wrapper?: { style?: CSSProperties; className?: string };
}

function HeaderWithTitleAndBackButton({
  title: { text, color },
  backIconEl,
  wrapper: { className = "", style } = {},
  backRoute = ROUTES.ROOT.DASHBOARD,
}: HeaderWithTitleAndBackButtonProps) {
  const navigate = useNavigate();

  return (
    <header
      className={`header-with-title-and-back-btn position-relative ${className}`}
      style={style}
    >
      <GhostButton
        onClick={() => navigate(backRoute)}
        className="position-relative"
        style={{ zIndex: 10 }}
      >
        {backIconEl || (
          <ChevronLeftCircleIcon chevronColor="black" bgColor="#C7C7C780" />
        )}
      </GhostButton>
      <h1
        className="title position-absolute Hanson-700 SpecialFontSettings"
        style={{ color }}
      >
        {text}
      </h1>
    </header>
  );
}

export default HeaderWithTitleAndBackButton;
